import { render, staticRenderFns } from "./ReportActivitiesWidget.vue?vue&type=template&id=9c3285d6&scoped=true&"
import script from "./ReportActivitiesWidget.vue?vue&type=script&lang=js&"
export * from "./ReportActivitiesWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportActivitiesWidget.vue?vue&type=style&index=0&id=9c3285d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3285d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c3285d6')) {
      api.createRecord('9c3285d6', component.options)
    } else {
      api.reload('9c3285d6', component.options)
    }
    module.hot.accept("./ReportActivitiesWidget.vue?vue&type=template&id=9c3285d6&scoped=true&", function () {
      api.rerender('9c3285d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportActivitiesWidget.vue"
export default component.exports